<!-- Sidebar Component -->
<app-sidebar></app-sidebar>

<!-- Mobile Sidebar Backdrop Overlay -->
<div
  class="sidebar-overlay"
  [class.show]="layoutService.isMobileSidebarOpen()"
  (click)="layoutService.closeMobileSidebar()"
></div>

<!-- Main Content Wrapper -->
<div class="main-wrapper">
  <!-- Top Navbar -->
  <app-navbar></app-navbar>

  <!-- Router Outlet Container -->
  <div class="main-content-body p-3 p-md-4">
    <router-outlet></router-outlet>
  </div>

  <!-- Footer Component -->
  <footer class="footer-custom">
    <div class="footer-left">
      <span class="footer-logo">
        <i class="bi bi-plus-lg"></i> Equity+
      </span>
      <span class="footer-separator">|</span>
      <span class="footer-copy">&copy; {{ currentYear }} Equity Plus - Todos os direitos reservados.</span>
    </div>
    <div class="footer-right">
      <ul class="footer-links">
        <li><a routerLink="/dashboard" class="footer-link">Dashboard</a></li>
        <li><a routerLink="/sales" class="footer-link">Vendas</a></li>
        <li><a routerLink="/duplicatas" class="footer-link">Duplicatas</a></li>
      </ul>
    </div>
  </footer>
</div>

<!-- Global Toasts & Error Modals -->
<app-toast-container></app-toast-container>
<app-error-modal></app-error-modal>
